export default {
  ALERT: 'error',
  WARNING: 'warning',
  FACT: 'fact',
  INFO: 'info',
};
